var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 22,
    viewBox: "0 0 50 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C0.895432 4 4.82823e-08 3.10457 0 2C-4.82823e-08 0.895433 0.89543 2.05901e-06 2 2.01072e-06L48 0C49.1046 -4.82823e-08 50 0.89543 50 2C50 3.10457 49.1046 4 48 4L2 4Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22C0.895433 22 1.35963e-06 21.1046 1.31134e-06 20C1.26306e-06 18.8954 0.895432 18 2 18L48 18C49.1046 18 50 18.8954 50 20C50 21.1046 49.1046 22 48 22L2 22Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.abf36e0af3e7a5e14ab045aacad1963d.svg";
export { ForwardRef as ReactComponent };